const moreInformedType = {
  Yes: 1,
  No: 2,
  AboutTheSame: 3
}

export default moreInformedType;